class Defaults {
	static DataTableLanguage(itemNamePlural) {
		itemNamePlural = itemNamePlural.toLowerCase();

		return {
			info: __("Showing _START_-_END_ of _TOTAL_ %s", itemNamePlural),
			infoEmpty: __("Showing 0 %s", itemNamePlural),
			infoFiltered: __("(filtered from _MAX_ total %s)", itemNamePlural),
			zeroRecords: __("No %s to show", itemNamePlural),
			loadingRecords: "<i class=\"fa fa-pulse fa-fw fa-sync\"></i> " + __("Loading..."),
			paginate: {
				previous: "<i class=\"fa fa-chevron-left\"></i>",
				next: "<i class=\"fa fa-chevron-right\"></i>"
			}
		}
	}

	static get DataTableExportButtons() {
		return Defaults.DataTableButtonsWithOptions();
	}

	static DataTableButtonsWithOptions(options = {}) {
		let columnSelectors = [];

		let visibleOnly = true;
		if(typeof options.visibleOnly !== "undefined") {
			visibleOnly = options.visibleOnly;
		}

		if(visibleOnly) {
			columnSelectors.push(":visible");
		}

		let orientation = "portrait";
		if(options.orientation) {
			orientation = options.orientation;
		}

		let documentTitleParts = document.title.split(" | ");
		documentTitleParts.pop();

		let title = documentTitleParts.join(" | ");
		if(options.title) {
			title = options.title;
		}

		const exclusions = [];

		if(typeof options.includeFirstColumn !== "undefined") {
			if(!options.includeFirstColumn) {
				exclusions.push(":first-child");
			}
		}

		if(typeof options.includeLastColumn !== "undefined") {
			if(!options.includeLastColumn) {
				exclusions.push(":last-child");
			}
		}

		if(exclusions.length > 0) {
			columnSelectors.push(":not(" + exclusions.join(", ") + ")");
		}

		let columnSelector = columnSelectors.join(" ");

		let messageTop = null;
		if(options.messageTop) {
			messageTop = options.messageTop;
		}

		const exportOptions = {
			columns: columnSelector
		};

		const printOptions = {
			columns: columnSelector,
			stripHtml: false
		};

		return [
			{
				extend: "excelHtml5",
				title: title,
				exportOptions: exportOptions,
				messageTop: messageTop
			},
			{
				extend: "copyHtml5",
				title: title,
				footer: true,
				exportOptions: exportOptions,
				messageTop: messageTop
			},
			{
				extend: "csvHtml5",
				title: title,
				exportOptions: exportOptions,
				filename: function(){
					if(options.filename) {
						return options.filename
					}

					return "*";
				}
			},
			{
				extend: "pdfHtml5",
				title: title,
				footer: true,
				exportOptions: exportOptions,
				orientation: orientation,
				messageTop: messageTop
			},
			{
				extend: "print",
				title: title,
				footer: true,
				exportOptions: printOptions,
				messageTop: messageTop
			},
			{
				text: "JSON",
				className: "buttons-json",
				action: function (e, dt) {
					const data = dt.buttons.exportData(exportOptions);

					$.fn.dataTable.fileSave(
						new Blob( [ JSON.stringify( data ) ] ),
						"Export.json"
					);
				}
			},
			{
				text: "XML",
				className: "buttons-xml",
				action: function (e, dt) {
					const data = dt.buttons.exportData(exportOptions);

					let xml = '<?xml version="1.0" encoding="UTF-8"?>\n';
					xml = xml + '<Rows>\n';

					for (let i = 0; i < data.body.length; i++){
						xml = xml + '\t<Row>\n';

						for(let j = 0; j < data.header.length; j++){
							xml = xml + '\t\t<' + data.header[j].replaceAll(" ", "") + '><![CDATA[' + data.body[i][j] + ']]></' + data.header[j] + '>\n';
						}

						xml = xml + '\t</Row>\n';
					}

					xml = xml + '</Rows>';

					$.fn.dataTable.fileSave(
						new Blob( [ xml ] ),
						'Export.xml'
					);
				}
			}
		];
	}

	static get DataTableExportInitComplete() {
		return (settings) => {
			const api = $.fn.dataTable.Api(settings);

			const $buttons = $('.dt-buttons');
			$('#action-print').on('click', () => $buttons.find('.buttons-print').trigger("click"));
			$('#action-csv').on('click', () => $buttons.find('.buttons-csv').trigger("click"));
			$('#action-excel').on('click', () => $buttons.find('.buttons-excel').trigger("click"));
			$('#action-pdf').on('click', () => $buttons.find('.buttons-pdf').trigger("click"));
			$('#action-json').on('click', () => $buttons.find('.buttons-json').trigger("click"));
			$('#action-xml').on('click', () => $buttons.find('.buttons-xml').trigger("click"));
			$('#action-copy').on('click', () => $buttons.find('.buttons-copy').trigger("click"));

			let documentTitleParts = document.title.split(" | ");
			documentTitleParts.pop();

			let title = documentTitleParts.join(" | ");

			api.on("buttons-action", (event, buttonApi, dataTable, node, config) => {
				const message = `The ${buttonApi.text()} button was clicked on the ${title} page.`;

				$.App.post(`/api/log-datatables-export`, {
					message
				});
			});
		}
	}

	static get DateRangePickerOptions() {

		const ranges = {};
		ranges[__("Today")] = [moment(), moment()];
		ranges[__("Yesterday")] = [moment().subtract(1, "days"), moment()];
		ranges[__("Last 7 Days")] = [moment().subtract(6, "days"), moment()];
		ranges[__("Last 30 Days")] = [moment().subtract(29, "days"), moment()];
		ranges[__("This Month")] = [moment().startOf("month"), moment().endOf("month")];
		ranges[__("Last Month")] = [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")];
		ranges[__("Last 6 Months")] = [moment().subtract(6, "month"), moment()];
		ranges[__("Q1")] = [moment().startOf("year"), moment().startOf("year").quarter(1).endOf('quarter')];
		ranges[__("Q2")] = [moment().startOf("year").quarter(2).startOf('quarter'), moment().startOf("year").quarter(2).endOf('quarter')];
		ranges[__("Q3")] = [moment().startOf("year").quarter(3).startOf('quarter'), moment().startOf("year").quarter(3).endOf('quarter')];
		ranges[__("Q4")] = [moment().startOf("year").quarter(4).startOf('quarter'), moment().startOf("year").quarter(4).endOf('quarter')];
		ranges[__("Year to Date")] = [moment().startOf("year"), moment()];
		ranges[__("Last Year")] = [moment().subtract(1, "year").startOf("year"), moment().subtract(1, "year").endOf("year")];

		return {
			showDropdowns: true,
			autoApply: true,
			drops: "auto",
			locale: {
				format: 'DD/MM/YYYY',
				firstDay: 1
			},
			ranges: ranges
		};
	}

	static get DateRangePickerSingleDateOptions() {
		return {
			singleDatePicker: true,
			showDropdowns: true,
			autoApply: true,
			drops: "auto",
			locale: {
				format: 'DD/MM/YYYY',
				firstDay: 1
			}
		};
	}

	static get DateRangePickerSingleDateTimeOptions() {
		return {
			singleDatePicker: true,
			timePicker: true,
			timePickerIncrement: 1,
			timePicker24Hour: true,
			showDropdowns: true,
			autoApply: true,
			drops: "auto",
			locale: {
				format: "DD/MM/YYYY HH:mm",
				firstDay: 1
			}
		};
	}

	static get PasstrengthOptions() {
		return {
			minChars: 6,
			textWeak: __("Weak"),
			textMedium: __("Medium"),
			textStrong: __("Strong"),
			textVeryStrong: __("Very Strong"),
			eyeImg : "/img/eye.svg"
		};
	}

	static get LatLng() {
		return {
			lat: 51.5383893,
			lng: 0.7139444
		};
	}

	static get FroalaOptions() {
		return {
			key: $("#froala-key").val(),
			fontFamily: {
				"Arial,sans-serif": "Arial",
				"Georgia,serif": "Georgia",
				"Impact,sans-serif": "Impact",
				"Montserrat,sans-serif": "Montserrat",
				"Nunito,sans-serif": "Nunito",
				"Tahoma,sans-serif": "Tahoma",
				"Times New Roman,serif": "Times New Roman",
				"Verdana,sans-serif": "Verdana",
			},
			fontFamilySelection: true,
			fontSizeSelection: true,
			fontSize: ["8", "9", "10", "11", "12", "13", "14", "18", "24", "30", "36", "48", "60", "72", "96"],
			charCounterCount: false,
			height: 320,
			heightMax: 320,
			zIndex: 3000,
			enter: FroalaEditor.ENTER_BR,
			useClasses: false,
			pluginsEnabled: ["wordPaste", "link", "fontFamily", "fontSize", "align", "colors", "image", "imageManager"]
		};
	}

	static get FroalaEmailOptions() {
		const options = Defaults.FroalaOptions;
		options.toolbarButtons = ['fontFamily', 'fontSize', 'align', 'bold', 'italic', 'underline', 'strikeThrough', 'formatUL', 'formatOL', 'outdent', 'indent', 'textColor', 'insertImage', 'insertTable', 'insertHR', 'insertLink', '|', 'clearFormatting', 'undo', 'redo'];

		options.imageManagerLoadParams = {
			csrf_token: $.App.getCsrfToken(),
			froala: 1
		};
		options.imageManagerLoadURL = "/media-libraries/images";
		options.imageInsertButtons = ["imageBack", "|", "imageUpload", "imageByURL", "imageManager"];

		options.imageUploadURL = "/media-libraries/upload";
		options.imageUploadParams = {
			csrf_token: $.App.getCsrfToken(),
			froala: 1
		};
		options.imageUploadMethod = "POST";
		options.imageUploadMaxSize = 5 * 1024 * 1024;
		options.imageUploadAllowedTypes = ["jpeg", "jpg", "png"];
		options.events = {};

		options.events["image.error"] = (error, response) => {
			if(error.code === 1) toastr.error(__("Apex27 returned bad image URL."));
			else if(error.code === 2) toastr.error(__("Apex27 returned no image URL."));
			else if(error.code === 3) toastr.error(__("Error occurred during image upload."));
			else if(error.code === 4) toastr.error(__("Failed to parse response."));
			else if(error.code === 5) toastr.error(__("Image is too large."));
			else if(error.code === 6) toastr.error(__("Invalid image type."));
		};

		options.tableCellStyles = {
			"fr-no-border": "No Border",
			"fr-highlighted": "Highlighted",
			"fr-thick": "Thick",
		};

		return options;
	}

	static get DropzoneOptions() {
		return {
			parallelUploads: 1,
			timeout: 1800000,
			init: function() {
				this.on("error", (file, errorJsonString) => {
					const $messageElement = $(file.previewElement).find("div.dz-error-message");
					if(typeof errorJsonString === "string") {
						$messageElement.text(errorJsonString);
					}
					else {
						const error = JSON.parse(errorJsonString);
						if(typeof error != "object") {
							return;
						}
						$messageElement.text(error.message);
					}
				});
			}
		};
	}
}
